/** Copies text: the clipboard where the browser allows it, else the old way (an embedded or older browser). True
    when it went. */
export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (e) {
    const box = document.createElement('textarea');
    box.value = text;
    box.setAttribute('readonly', '');
    Object.assign(box.style, { position: 'fixed', top: '0', left: '0', opacity: '0' });
    document.body.appendChild(box);
    box.select();
    let ok = false;
    try { ok = document.execCommand('copy'); } catch (e2) { ok = false; }
    document.body.removeChild(box);
    return ok;
  }
}
